import { Selector } from "@ngxs/store";
import { DownloadOptionsState, DownloadOptionsStateModel } from "./download-options.state";

export class DownloadOptionsGetterState {
  @Selector([DownloadOptionsState])
  static getDownloadOptions(state: DownloadOptionsStateModel) {
    return state.ids.map(id => state.entities[id]);
  }
}